import React, { useState } from "react";
import styles from "./Tips.module.scss";
import blackIcon from "../../img/tips/blackIcon.png";
import whiteIcon from "../../img/tips/whiteIcon.png";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
const Tips = ({ tipsRef }) => {
  const [initialized, setInitialized] = useState(false);
  const location = useLocation();
  const trackingEvent = (title) => {
    if (!window.location.href.includes("localhost")) {
      ReactGA.initialize(process.env.REACT_APP_GA_ID);
      setInitialized(true);
    }
    if (initialized) {
      ReactGA.set({ page: location.pathname });
      ReactGA.event({
        category: "Tips",
        action: `${title}_click`,
        label: title,
      });
    }
  };
  return (
    <div className={styles.container} ref={tipsRef}>
      <h1 data-content="Tips">Tips</h1>
      <div className={styles.readme_box}>
        <div>
          <span className={styles.readme_title}>
            <p>What is Hybrid-Casual to MondayOFF?</p>
          </span>
          <a
            className={styles.readme_btn}
            href="https://events.mondayoff.me/hybrid-casual"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackingEvent("hybrid-casual")}
          >
            Read more
          </a>
          <img className={styles.first_black_icon} src={blackIcon} alt="" />
        </div>
        <div>
          <span className={styles.readme_title}>
            <p>How to ITR your game to improve metrics.</p>
          </span>
          <a
            className={styles.readme_btn}
            href="https://events.mondayoff.me/improve-metrics"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackingEvent("improve-metrics")}
          >
            Read more
          </a>
          <img className={styles.white_icon} src={whiteIcon} alt="" />
        </div>

        <div>
          <span className={styles.readme_title}>
            <p>Practical Tips for Making Impactful Creatives</p>
          </span>
          <a
            className={styles.readme_btn}
            href="https://events.mondayoff.me/practical-tips"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackingEvent("practical-tips")}
          >
            Read more
          </a>
          <img className={styles.second_black_icon} src={blackIcon} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Tips;
